import { FC, memo } from "react";

const Repeat: FC = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5V2.94319C12 2.12982 11.0806 1.65669 10.4188 2.12946L6.13923 5.18627C5.58088 5.58509 5.58088 6.41491 6.13923 6.81373L10.4188 9.87054C11.0806 10.3433 12 9.87018 12 9.05681V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C9.02918 19 6.55781 16.833 6.08251 13.9958C5.99126 13.4511 5.55228 13 5 13C4.44772 13 3.99345 13.45 4.06158 13.998C4.55243 17.9466 7.91799 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default memo(Repeat);
